<template>
	<div class="login_container">
		<div class="login_ding">
			<div class="login_nei">
				<img src="../../assets/img/logo.png" alt="">
				<div>零代码&数字孪生教学实训平台</div>
				<div class="bbb">
					<a href="http://ws-nocode.com:81/teacher" target="_blank" >教师端</a>
					<a href="http://ws-nocode.com:81/student" target="_blank" >学生端</a>
				</div>
			</div>
		</div>
		
		<div class="login_box">
			<img  class="loginind" src="../../assets/img/loginmin.jpg" alt="">
			<div class="login_info">
				<div class="login_ipt">
					<div class="login_title">管理端登录</div>
					<el-form ref="formlogin" :model="loginForm" :rules="loginformRules">
						<el-form-item prop="student" style="width: 440px;margin: 0 auto 30px;">
							<el-input class="login_input" maxlength="11" v-model="loginForm.manager_name" placeholder="请输入账户名称"
								prefix-icon="el-icon-user-solid" type="text" ></el-input>
						</el-form-item>	
						<el-form-item prop="password" style="width: 440px;margin: 0 auto 30px;">
							<el-input class="login_input" maxlength="16" v-model="loginForm.password" placeholder="请输入账户密码"
								prefix-icon="el-icon-s-goods" type="password" @keyup.enter.native="login"  prop="password"></el-input>
						</el-form-item>		
						 
						<div class="hr">
							<div class="hr_left" @click="sel()">
								<img v-if="show" src="../../assets/img/zhong.png" alt="">
								<img v-else src="../../assets/img/xuan.png" alt="">
								<div>记住用户名</div>
							</div>
							<div class="hr_right" @click="wang">忘记密码？</div>
						</div>
						<div class="login_btn" @click="login">登录</div>
					</el-form>
				</div>
			</div>
		</div> 
		<!-- 忘记密码 -->
		<el-dialog :visible.sync="open" width="800px" append-to-body>
		   <div class="dialog_title">修改密码</div>
		   <div class="dialog_text">忘记原始密码请联系管理员进行密码的修改</div>
		   <div class="nice" @click="nice">我知道了</div>
		</el-dialog>
	</div>
</template>

<script>
	import "element-ui/lib/theme-chalk/index.css";
	import {getlogin} from "../../api/new.js";
	export default {
		components: {},
		data() {
			return {
				show: false, //记住用户名
				open:false,
				loginForm: {
					manager_name: "",
					password: "",
				},
				loginformRules: {
					// 验证用户名是否合法
					manager_name: [{
							required: true,
							message: "请输入账户名称",
							trigger: "blur"
						}
					],
					password: [{
						required: true,
						message: "请输入密码",
						trigger: "blur"
					}],
				},
			};
		},
		methods: {
			wang(){
				this.open = true
			},
			nice(){
				this.open = false
			},
			//记住用户名
			sel(){
				this.show = !this.show
			},
			login() {
				var _this = this
				this.$refs.formlogin.validate(async (valid) => {
				    if (!valid) return;
				    getlogin(this.loginForm).then((res) => {
				    	if (res.code == 0) {
				    		this.$message.success('登录成功');
				    		localStorage.setItem('token', res.token);
				    		setTimeout(function(){
				    			_this.$router.push({ path: "/Teacher"});
				    		},1000)
				    	} else {
				    		this.$message.error(res.msg);
				    	}
				    })
				    .catch((err) => {
						console.log(err);
				    });
				});
			},

		},
	};
</script>

<style lang="less" scoped>
	.login_container {
		width: 100%;
		height: 100vh;
		background: #FFFFFF;
		overflow: auto;
		display: flex;
		align-items: center;
		justify-content: center;
		.login_ding{
			width: 100%;
			height: 80px;
			background: #FFFFFF;
			border-bottom: 1px solid #E6E6E6;
			position: absolute;
			z-index: 9;
			top:0;
			left: 0;
			.login_nei{
				width: 1200px;
				height: 80px;
				margin: 0 auto;
				line-height: 80px;
				display: flex;
				align-items: center;
				// justify-content: space-between;
				.img{
					width: 150px;
				}
				div{
					font-size: 24px;
					font-weight: bold;
					color:#104099;
					margin-left: 20px;
				}
				.bbb{
					margin-left: auto;
					a{
						font-size: 16px;
						color: #007AFF;
						font-weight: normal;
						text-decoration-line: none;
						margin-left: 10px;
					}
				}
				
			}
			
		}
		.login_box {
			width: 1200px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			.loginind {
				width: 650px;
				height: 444px;
				border-radius: 10px;
				// object-fit: cover;
				// display: block;
			}
			.login_info {
				width: 525px;
				// height: 481px;
				border: 1px solid #CCCCCC;
				border-radius: 20px;
				box-sizing: border-box;
				padding: 40px;
				.login_ipt {
					.login_title {
						font-size: 28px;
						color: #007AFF;
						line-height: 28px;
						text-align: center;
						font-weight: bold;
						margin-bottom: 30px;
					}

					.login_input {
						width: 440px;
						height: 65px;
						border: 1px solid #E6E6E6;
						display: block;
						margin: 0 auto;
						// margin-bottom: 35px;
					}
					
					.hr{
						width: 440px;
						display: flex;
						align-items: center;
						justify-content: space-between;
						margin: 0 auto;
						.hr_left{
							display: flex;
							align-items: center;
							cursor: pointer;
							img{
								width: 26px;
								height: 26px;
							}
							div{
								font-size: 18px;
								font-weight: 500;
								color: #000000;
								line-height: 18px;
								margin-left: 10px;
							}
						}
						.hr_right{
							font-size: 18px;
							font-weight: 500;
							color: #000000;
							line-height: 18px;
							cursor: pointer;
						}
					}
					
					.login_btn {
						width: 440px;
						height: 60px;
						background: #007AFF;
						font-size: 18px;
						color: #FFFFFF;
						line-height: 60px;
						text-align: center;
						margin: 0 auto;
						margin-top: 30px;
						cursor: pointer;
					}

					.login_btn:hover {
						opacity: 0.7;
					}

					.login_btn:active {
						opacity: 0.9;
					}
				}
			}
		}
		
	}
	.dialog_title{
		width: 100%;
		font-size: 24px;
		font-family: PingFang SC;
		font-weight: bold;
		color: #1A1A1A;
		line-height: 48px;
		text-align: center;
	}
	.dialog_text{
		width: 100%;
		font-size: 20px;
		font-family: PingFang SC;
		color: #1A1A1A;
		line-height: 48px;
		margin-top: 40px;
		text-align: center;
	}
	.nice {
		width: 140px;
		height: 52px;
		background: #007AFF;
		border-radius: 25px;
		font-size: 18px;
		color: #FFFFFF;
		line-height: 52px;
		text-align: center;
		margin: 0 auto;
		margin-top: 35px;
		cursor: pointer;
	}
	
	.nice:hover {
		opacity: 0.7;
	}
	
	.nice:active {
		opacity: 0.9;
	}
	
</style>



// WEBPACK FOOTER //
// src/components/login/login.vue